const StarIcon = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_941_636)">
			<path
				d="M5.49615 4.89231L1.24282 5.50897L1.16749 5.52431C1.05345 5.55458 0.949484 5.61458 0.866215 5.69817C0.782947 5.78177 0.723356 5.88596 0.693529 6.00012C0.663701 6.11428 0.664705 6.23431 0.696439 6.34795C0.728172 6.4616 0.789498 6.56478 0.874154 6.64697L3.95549 9.64631L3.22882 13.883L3.22015 13.9563C3.21317 14.0743 3.23766 14.1919 3.29112 14.2973C3.34458 14.4027 3.42508 14.492 3.52438 14.556C3.62368 14.62 3.73821 14.6565 3.85625 14.6617C3.97429 14.6669 4.0916 14.6407 4.19615 14.5856L8.00015 12.5856L11.7955 14.5856L11.8622 14.6163C11.9722 14.6596 12.0918 14.6729 12.2087 14.6548C12.3255 14.6367 12.4355 14.5878 12.5272 14.5131C12.619 14.4385 12.6892 14.3408 12.7307 14.2301C12.7722 14.1193 12.7835 13.9995 12.7635 13.883L12.0362 9.64631L15.1188 6.64631L15.1708 6.58964C15.2451 6.49815 15.2938 6.38861 15.312 6.27217C15.3301 6.15573 15.3171 6.03656 15.2742 5.92679C15.2313 5.81703 15.1601 5.72059 15.0678 5.64731C14.9755 5.57404 14.8654 5.52653 14.7488 5.50964L10.4955 4.89231L8.59415 1.03897C8.53914 0.927328 8.45397 0.833315 8.34828 0.767575C8.2426 0.701834 8.12062 0.666992 7.99615 0.666992C7.87169 0.666992 7.74971 0.701834 7.64403 0.767575C7.53834 0.833315 7.45317 0.927328 7.39815 1.03897L5.49615 4.89231Z"
				fill="#F79E1C"
			/>
		</g>
		<defs>
			<clipPath id="clip0_941_636">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default StarIcon;
